import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../Login.css';
import logo from '../../assets/img.png';
import axiosInstance from "../../api/axiosConfig.jsx";

const ResetPassword = () => {
    const { token } = useParams();
    const navigate = useNavigate();
    const [isValidToken, setIsValidToken] = useState(null);
    const [formData, setFormData] = useState({
        newPassword: '',
        confirmPassword: ''
    });
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);
    const [language, setLanguage] = useState('nl');

    const toggleLanguage = () => {
        setLanguage((prevLanguage) => (prevLanguage === 'nl' ? 'en' : 'nl'));
    };

    // Error messages in different languages
    const errorMessages = {
        nl: {
            invalidToken: 'Ongeldige of verlopen link.',
            passwordMismatch: 'Wachtwoorden komen niet overeen.',
            resetError: 'Fout bij het resetten van het wachtwoord.',
            passwordRequirements: 'Wachtwoord moet minimaal 8 tekens bevatten, waaronder een hoofdletter, een cijfer en een speciaal teken.',
        },
        en: {
            invalidToken: 'Invalid or expired link.',
            passwordMismatch: 'Passwords do not match.',
            resetError: 'Error resetting password.',
            passwordRequirements: 'Password must be at least 8 characters long and include an uppercase letter, a number, and a special character.',
        },
    };



    const validatePassword = (password) => {
        const regex = /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/;
        return regex.test(password);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setSuccess(null);

        // Validate passwords match
        if (formData.newPassword !== formData.confirmPassword) {
            setError(errorMessages[language].passwordMismatch);
            return;
        }

        // Validate password requirements
        if (!validatePassword(formData.newPassword)) {
            setError(errorMessages[language].passwordRequirements);
            return;
        }

        try {
            const response = await axiosInstance.post(`/users/reset-password/${token}`, {
                newPassword: formData.newPassword
            });

            if (response.status === 200) {
                setSuccess(language === 'nl'
                    ? 'Wachtwoord succesvol gewijzigd!'
                    : 'Password successfully changed!');
                setTimeout(() => {
                    navigate('/login');
                }, 3000);
            }
        } catch (error) {
            console.log(error);
            setError(language === 'nl' ? errorMessages.nl.resetError : errorMessages.en.resetError);
        }
    };

    // Check if token is valid
    if (isValidToken === false) {
        return (
            <div className="container mt-5">
                <div className="alert alert-danger text-center">
                    <h4 className="alert-heading">{language === 'nl' ? 'Ongeldige of Verlopen Link' : 'Invalid or Expired Link'}</h4>
                    <p>{language === 'nl' ? 'Deze reset link is ongeldig of is verlopen. Vraag een nieuwe aan.' : 'This reset link is either invalid or has expired. Please request a new one.'}</p>
                </div>
            </div>
        );
    }

    return (
        <div className="container-fluid vh-100 d-flex justify-content-center align-items-center" style={{ backgroundColor: '#f8f9fa', minHeight: '100vh', minWidth: '100vw' }}>
            <div className="card shadow-lg p-4" style={{ maxWidth: '400px', width: '100%', borderRadius: '15px', backgroundColor: '#ffffff', maxHeight: '90vh', overflowY: 'auto' }}>
                <div className="text-center mb-4">
                    <img src={logo} alt="HorecaMasters Logo" style={{ maxWidth: '250px', height: '130px' }} />
                </div>
                <h2 className="text-center mb-4" style={{ fontSize: '1.5rem', color: '#343a40' }}>
                    {language === 'nl' ? 'Wachtwoord Resetten' : 'Reset Password'}
                </h2>

                {error && <div className="alert alert-danger">{error}</div>}
                {success && <div className="alert alert-success">{success}</div>}

                <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                        <label htmlFor="newPassword" className="form-label">
                            {language === 'nl' ? 'Nieuw Wachtwoord' : 'New Password'}
                        </label>
                        <input
                            type="password"
                            className="form-control"
                            id="newPassword"
                            name="newPassword"
                            value={formData.newPassword}
                            onChange={handleChange}
                            placeholder={language === 'nl' ? 'Voer nieuw wachtwoord in' : 'Enter new password'}
                            required
                        />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="confirmPassword" className="form-label">
                            {language === 'nl' ? 'Bevestig Wachtwoord' : 'Confirm Password'}
                        </label>
                        <input
                            type="password"
                            className="form-control"
                            id="confirmPassword"
                            name="confirmPassword"
                            value={formData.confirmPassword}
                            onChange={handleChange}
                            placeholder={language === 'nl' ? 'Bevestig nieuw wachtwoord' : 'Confirm new password'}
                            required
                        />
                    </div>
                    <button type="submit" className="btn btn-success w-100">
                        {language === 'nl' ? 'Wachtwoord Wijzigen' : 'Change Password'}
                    </button>
                    <div className="form-check form-switch mt-3 text-center">
                        <input
                            className="form-check-input"
                            type="checkbox"
                            id="languageSwitch"
                            onChange={toggleLanguage}
                            checked={language === 'en'}
                        />
                        <label className="form-check-label" htmlFor="languageSwitch">
                            {language === 'nl' ? 'Schakel naar Engels' : 'Switch to Dutch'}
                        </label>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ResetPassword;